import React from "react";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const VendorManagementCreate = () => {
  // Fetch stored user data
  const userData = getStoredData()?.[1] || {}; // Ensure userData is an object


  return (
    <div>
      <h2>Create New {userData.TitleUser}</h2>
      <DynamicForm
        fields={userData.AdminUser} 
        apiUrl={userData.ApiUserRegister} 
        successRedirect={userData.RedirectAdminUser} 
      />
    </div>
  );
};

export default VendorManagementCreate;
